import React from "react";
import { cn } from "@/shared/lib/utils";
import { useAppContext } from "@/shared/hooks/useAppContext";
import FullscreenLayout from "./FullScreenLayout";
import CircularProgress from "@/shared/components/CircularProgress";
import { AppSidebar } from "./components/nav/AppSidebar";
import { SidebarProvider } from "@/shared/components/ui/sidebar";
import { SimulationBanner } from "./components/nav/SimulationBanner";
import { MainTopNav } from "./components/MainTopNav";
type Props = React.PropsWithChildren & {
  className?: string;
  header?: React.ReactNode;
  actions?: React.ReactNode;
  banner?: React.ReactNode;
  hideTopNav?: boolean;
};

function MainLayoutInner({ children, className, header, actions, banner, hideTopNav }: Props) {
  return (
    <SidebarProvider>
      <div className="mt-[var(--app-content-offset)] h-[calc(100dvh_-_var(--app-content-offset))] w-full flex flex-col overflow-hidden">
        <SimulationBanner />
        <div className="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-[auto_1fr] overflow-hidden">
          <AppSidebar />
          <div className="flex h-full flex-col overflow-y-auto bg-subtle">
            <MainTopNav header={header} actions={actions} hidden={hideTopNav} />
            {banner}
            <div className="flex flex-1 justify-center">
              <div className={cn("w-full max-w-[1300px] px-4 py-4 md:px-10 md:py-10", className)}>
                {header && (
                  <div className="lg:hidden text-lg font-semibold pb-2 truncate">{header}</div>
                )}
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
}

const MainLayout = ({ children, className, header, actions, banner, hideTopNav }: Props) => {
  const { isLoading } = useAppContext();
  if (isLoading) {
    return (
      <FullscreenLayout>
        <CircularProgress />
      </FullscreenLayout>
    );
  }

  return (
    <MainLayoutInner
      className={className}
      header={header}
      actions={actions}
      banner={banner}
      hideTopNav={hideTopNav}
    >
      {children}
    </MainLayoutInner>
  );
};

export default MainLayout;
